export const DIMENSION_WHITELABELID = 'dimension1';
export const DIMENSION_PROGRAMID = 'dimension2';
export const DIMENSION_GROUPID = 'dimension3';
export const DIMENSION_USERID = 'dimension4';
